<template>
  <div
    class="accessory-conflict-wrap"
    :class="{ 'hidden': !$store.state.accessoryConflict.show }"
    v-on:click="hideAccessoryPopup()">
    <div
      class="accessory-conflict-content"
      v-on:click="$event.stopPropagation()">
      <article>
        <header>
          <p><i>{{ notice }}</i></p>
          <img src="../../assets/icons/alert-icon.svg"/>
        </header>
        <section>
          <h4>{{ question }}</h4>
          <div class="button-wrap" v-if="getT">
            <button
              class="no"
              v-on:click="resolve(false)">
              {{ getT.static.accessory_conflict[0].no }}
            </button>
            <button
              class="yes"
              v-on:click="resolve(true)">
              {{ getT.static.accessory_conflict[0].yes }}
            </button>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AccessoryConflict',
  props: [ 'notice', 'question', 'showPopup' ],
  computed:{
    ...mapGetters(['getT']),
  },
  methods: {
    resolve(result) {
      this.$store.commit('resolveConflict', result);
    },
    hideAccessoryPopup() {
      this.$store.commit('resolveConflict', false);
    },
  },
}
</script>
<style scoped lang="scss">

.accessory-conflict-wrap {
  position: absolute;
  z-index: 61;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.3);
  backdrop-filter: blur(3px);
  &.hidden {
    display: none;
  }
  .accessory-conflict-content {
    position: relative;
    width: calc(100% - 2em);
    max-width: 23em;
    background-color: $navy;
    box-shadow: 0 3px 24px rgba(0,0,0,0.5);
    overflow: hidden;
    article {
      padding: 1.5em 1em;
      header {
        display: flex;
        p {
          color: $muted-white;
        }
        img {
          margin: 0 .3em;
        }
      }
      section {
        padding: .5em 0;
        h4 {
          margin: 1em 0 2em 0;
          color: white;
          font-size: 1.125rem;
          letter-spacing: 2.24px;
        }
        .button-wrap {
          display: flex;
          justify-content: space-around;
          button {
            width: 100%;
          }
          button.no {
            margin-right: .4em;
            background-color: $deep-navy;
            border-color: $deep-navy;
            &:hover {
              background-color: darken($deep-navy, 3%);
              border-color: darken($deep-navy, 3%);
            }
          }
        }
      }
    }
  }
}
</style>
